import React from 'react';
import styles from './App.module.css';

function App() {
  return (
    <div className={styles.app_container}>
      Twidere!
    </div>
  );
}

export default App;
